import angular from 'angular';
import PosChartComponent from './chart.component';

const posChartModule = angular.module('tinaba.components.dashboard.pos.chart', [])

.component('posChart', PosChartComponent);

export default posChartModule;



/** WEBPACK FOOTER **
 ** ./client/app/components/dashboard/pos/chart/chart.js
 **/